import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { IoIosNotificationsOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import white_logo from "../../images/white_logo.svg";
import { fetchProfile } from "../../redux/slices/profileSlice";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Dashboard");
  const navigate = useNavigate();
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);
  // const [profileInfo, setProfileInfo] = useState({});
  const location = useLocation();

  const dispatch = useDispatch();
  const [, , removeCookie] = useCookies(["reebukToken"]);
  const profileInfo = useSelector((state) => state?.profile?.data);

  useEffect(() => {
    if (!profileInfo) {
      dispatch(fetchProfile());
    }
  }, [profileInfo, dispatch]);

  useEffect(() => {
    const page = location.pathname.split("/")[1];

    switch (page) {
      case "dashboard":
        setActiveTab("Dashboard");
        break;
      case "consumer":
      case "consumerProfile":
      case "editProfile":
        setActiveTab("Consumer");
        break;
      case "scheduledAppointmentDetail":
        setActiveTab("Consumer");
        break;
      case "completedAppointmentDetail":
        setActiveTab("Consumer");
        break;
      case "cancelledAppointmentDetail":
        setActiveTab("Consumer");
        break;
      case "provider":
        setActiveTab("Provider");
        break;
      case "ProfileReview":
        setActiveTab("Provider");
        break;
      case "totalEarning":
        setActiveTab("Provider");
        break;
      case "advertisement":
        setActiveTab("Advertisement");
        break;
      case "support":
        setActiveTab("Support");
        break;
      case "providerProfile":
        setActiveTab("Provider");
        break;
      case "PendingRegistration":
        setActiveTab("Provider");
        break;
      case "completedAppointments":
        setActiveTab("Provider");
        break;
      case "completedPatientDetail":
        setActiveTab("Provider");
        break;
      case "scheduledAppointments":
        setActiveTab("Provider");
        break;
      case "scheduledPatientDetail":
        setActiveTab("Provider");
        break;
      case "cancelledAppointments":
        setActiveTab("Provider");
        break;
      case "cancelledPatientDetail":
        setActiveTab("Provider");
        break;
      case "pendingRequest":
        setActiveTab("Provider");
        break;
      case "pendingPatientDetail":
        setActiveTab("Provider");
        break;
      case "viewAllReview":
        setActiveTab("Provider");
        break;
      case "EditProviderInfo":
        setActiveTab("Provider");
        break;
      case "offers":
        setActiveTab("Offers");
        break;
      case "withdraw":
        setActiveTab("Withdraw Request");
        break;

      default:
        setActiveTab("Dashboard");
        break;
    }
  }, [location.pathname]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setIsOpen(false);
    navigate(`/${tab.toLowerCase()}`);
  };

  const handleLogout = () => {
    removeCookie("reebukToken", {
      path: "/",
      secure: true,
      httpOnly: false,
      sameSite: "Strict",
    }); // Remove authentication token
    navigate("/auth/Login"); // Redirect to login page
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const NavTabs = () => (
    <>
      {[
        "Dashboard",
        "Consumer",
        "Provider",
        "Advertisement",
        "Support",
        "Offers",
        "Withdraw",
      ].map((tab) => (
        <button
          key={tab}
          className={`w-full md:w-auto px-4 py-2 rounded-lg text-left md:text-center ${
            activeTab === tab
              ? "bg-white text-[#284184]"
              : "text-white hover:bg-[#6174a6]"
          }`}
          onClick={() => handleTabClick(tab)}
        >
          {tab === "Withdraw" ? "Withdraw Request" : tab}
        </button>
      ))}
    </>
  );

  return (
    <nav className="bg-[#284184] text-white">
      <div className="px-4 md:px-10 py-3">
        <div className="flex justify-between items-center">
          {/* Left Side: Brand and Logo */}
          <div className="flex items-center gap-5">
            <img src={white_logo} alt="Logo" />

            {/* Desktop Navigation Tabs */}
            <div className="hidden md:flex space-x-2">
              <NavTabs />
            </div>
          </div>

          {/* Right Side: User Profile */}
          <div className="flex items-center gap-3">
            <button onClick={() => navigate("/notifications")}>
              <IoIosNotificationsOutline size={30} />
            </button>
            <div
              className="flex items-center gap-2 cursor-pointer"
              onClick={() => setIsOpenDropdown(!isOpenDropdown)}
            >
              <img
                src={
                  profileInfo?.profile_image ||
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqafzhnwwYzuOTjTlaYMeQ7hxQLy_Wq8dnQg&s"
                }
                alt="User"
                className="w-10 h-10 rounded-lg"
              />
              <div>
                <span className="hidden lg:block text-sm">
                  {profileInfo?.name || ""}
                </span>
              </div>
            </div>

            {isOpenDropdown && (
              <div className="absolute right-2 top-16 bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-44 z-[1000]">
                <ul className="py-2 text-sm text-[#284184]">
                  <li>
                    <button
                      // href="/profile"
                      className="block w-full text-left px-4 py-2 border-b hover:bg-[#284184] hover:rounded-lg hover:text-white"
                      onClick={() => {
                        navigate("/profile", { state: { profileInfo } });
                        setIsOpenDropdown(!isOpenDropdown);
                      }}
                    >
                      Edit Profile
                    </button>
                  </li>
                  <li>
                    <button
                      // href="/profile"
                      className="block w-full text-left px-4 py-2 border-b hover:bg-[#284184] hover:rounded-lg hover:text-white"
                      onClick={() => {
                        navigate("/change-password");
                        setIsOpenDropdown(!isOpenDropdown);
                      }}
                    >
                      Change Password
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={handleLogout}
                      className="block w-full text-left px-4 py-2 hover:bg-[#284184] hover:rounded-lg hover:text-white"
                    >
                      Sign out
                    </button>
                  </li>
                </ul>
              </div>
            )}

            {/* Mobile Menu Toggle */}
            <button
              className="md:hidden ml-3 text-white focus:outline-none"
              onClick={toggleMenu}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isOpen && (
          <div className="md:hidden mt-4 space-y-2">
            <NavTabs />
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
